import React, { useState } from "react";
import axios from "axios";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";

export default function Weather(props) {

  let [city, setCity] = useState(props.defaultCity);
  
  let [weatherData, setWeatherData] = useState({ ready: false });

  function handleResponse(response) {
    
    setWeatherData({
      ready: true,
      city: response.data.city,
      temperature: response.data.temperature.current,
      wind: response.data.wind.speed,
      description: response.data.condition.description,
      humidity: response.data.temperature.humidity,
      iconUrl: response.data.condition.icon_url,
      time: new Date(response.data.time * 1000),
    });
  }

function search() {
  let apiKey = "o8da94538210e4d3f40a1336t5f0ebb4";
  let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;
  axios.get(apiUrl).then(handleResponse);
}

function handleSubmit(event) {
  event.preventDefault();
  search();
}

function handleCityChange(event) {
setCity(event.target.value);
}
  if (weatherData.ready) {
  return (
  <div class="container">
  <div class="weather-app-wrapper">
    <div class="weather-app">
      <form onSubmit={handleSubmit} id="search-form" class="mb-3">
        <div class="row">
          <div class="col-9">
            <input
            onChange={handleCityChange}
              type="search"
              placeholder="Type a city..."
              class="form-control"
              id="city-input"
              autocomplete="off"
            />
          </div>
          <div class="col-3">
            <input
              type="submit"
              value="Search"
              class="btn btn-primary w-100"
            />
          </div>
        </div>
      </form>
<WeatherInfo data={weatherData} />
<WeatherForecast city={weatherData.city}/>
     
      <div class="weather-forecast" id="forecast"></div>
    </div>
    <p>
      <a href="https://github.com/NataliiaGit/weather-react.git"
        >Open-source code,
      </a>
      by Nataliia Melnychenko
    </p>
  </div>
</div>)
}
else {
search();
return "Loading...";

}
  }
  